<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (click)="Save()"></app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Valet Station Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name" [Required]="true">
              <p class="control">
                <input formControlName="Name" class="input is-fullwidth" type="text" />
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </p>
            </app-field>
            <app-field Label="High Volume Mode">
              <p class="control">
                <app-toggleswitch formControlName="HighVolumeModeEnabled"></app-toggleswitch>
              </p>
            </app-field>
            <app-field Label="Send SMS Survey">
              <p class="control">
                <app-toggleswitch formControlName="SendSmsSurvey"></app-toggleswitch>
              </p>
            </app-field>
            @if (Form.get('SendSmsSurvey')?.value) {
              <app-field Label="Survey Delay (minutes)">
                <p class="control">
                  <input formControlName="SurveyDelay" class="input" type="number" min="0" />
                  <app-validator [For]="this.Form.get('SurveyDelay')"></app-validator>
                </p>
              </app-field>
            }
            <app-field Label="Expected Wait Time (minutes)">
              <p class="control">
                <input formControlName="ExpectedWaitTime" class="input" type="number" min="0" />
                <app-validator [For]="this.Form.get('ExpectedWaitTime')"></app-validator>
              </p>
            </app-field>
            @if (ValetTypes) {
              <app-field Label="Default Valet Type">
                <div class="select is-fullwidth">
                  <select formControlName="DefaultValetTypeId">
                    <option [ngValue]="null">-- None --</option>
                    @for (t of ValetTypes; track t) {
                      <option [ngValue]="t.Id">{{t.Name}}</option>
                    }
                  </select>
                </div>
              </app-field>
            }
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Session Summary
          </p>
          <div class="panel-block">
            <span class="label">Today's Sessions:</span>
            <span class="value">{{Model.TodaySessionCount}}</span>
          </div>
          @if (Model.SessionCountsByState?.length > 0) {
            <p class="panel-heading is-size-7">
              Sessions by State
            </p>
          }
          @for (state of Model.SessionCountsByState; track state) {
            <div class="panel-block">
              <span class="label">{{state.StateName}}:</span>
              <span class="value">{{state.Count}}</span>
            </div>
          }
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Parking Lots
          </p>
          <div class="panel-block" style="display: block;" formArrayName="ParkingLots">
            @if (FormArray(Form, 'ParkingLots').controls.length > 0) {
              <table class="table is-striped is-bordered input-table">
                <thead>
                  <tr>
                    <th>Parking Lot</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of FormArray(Form, 'ParkingLots').controls; track line; let i = $index) {
                    <tr [formGroupName]="i"
                      >
                      <td>
                        {{line.get('ParkingLotName')?.value || line.get('ParkingLotId')?.value}}
                      </td>
                      <td>
                        <div class="control">
                          <button class="button is-light" (click)="RemoveParkingLot(i)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            <div class="button is-primary" (click)="AddParkingLot()">
              Add Parking Lot
            </div>
            <app-validator [For]="this.FormArray(Form, 'ParkingLots')"></app-validator>
          </div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">
            Payment Terminals
          </p>
          <div class="panel-block" style="display: block;" formArrayName="PaymentTerminals">
            @if (FormArray(Form, 'PaymentTerminals').controls.length > 0) {
              <table class="table is-striped is-bordered input-table">
                <thead>
                  <tr>
                    <th style="width: 1%; white-space: nowrap;">Type</th>
                    <th style="width: 33%;">Serial Number</th>
                    <th style="width: 33%;">Device Id</th>
                    <th style="width: 33%;">POS Name</th>
                    <th style="width: 1%; white-space: nowrap;"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of FormArray(Form, 'PaymentTerminals').controls; track line; let i = $index) {
                    <tr [formGroupName]="i"
                      >
                      <td style="width: 1%; white-space: nowrap;">
                        {{TerminalTypeName(line.get('TerminalType')?.value)}}
                      </td>
                      @if (line.get('TerminalType')?.value == WindcaveHITTerminalType) {
                        <td style="width: 33%;">
                          <p class="control">
                            <input formControlName="SerialNumber" class="input" type="text" />
                            <app-validator [For]="line.get('SerialNumber')"></app-validator>
                          </p>
                        </td>
                      }
                      @if (line.get('TerminalType')?.value == WindcaveHITTerminalType) {
                        <td style="width: 33%;">
                          <p class="control">
                            <input formControlName="DeviceId" class="input" type="text" />
                            <app-validator [For]="line.get('DeviceId')"></app-validator>
                          </p>
                        </td>
                      }
                      @if (line.get('TerminalType')?.value == WindcaveHITTerminalType) {
                        <td style="width: 33%;">
                          <p class="control">
                            <input formControlName="PosName" class="input" type="text" />
                            <app-validator [For]="line.get('PosName')"></app-validator>
                          </p>
                        </td>
                      }
                      <td style="width: 1%; white-space: nowrap;">
                        <div class="control">
                          <button class="button is-light" (click)="RemovePaymentTerminal(i)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            <div class="button is-primary" (click)="AddPaymentTerminal(WindcaveHITTerminalType)">
              Add Windcave HIT Terminal
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}
